import { combineReducers } from "@reduxjs/toolkit";
import promotional from "./promotional-coupons.slice";
import reservations from "./coupon-reservations.slice";

const reducer = combineReducers({
  promotional,
  reservations,
});

export default reducer;
